import React from 'react';
import Link from 'gatsby-link';

const Footer = () => (
  <div className="footer">
    <p className="right">
      <Link to="/">Shed Labs s.r.o. &copy; 2018</Link>
    </p>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js